<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex>
        <formAdminAccountsDatatable
          :title="'List of AWS accounts'"
          :type="'byAwsAgreement'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({

  }),
  computed: {
  },
  methods: {
  },
  mounted() {
    console.log('getting accounts')
    // this.$store.commit('admin/accountInventory/resetAccountFilters')
    this.$store.commit('admin/accountInventory/clearAccounts')
    this.$store.commit('admin/accountInventory/removeSearchValue')
    this.$store.dispatch('admin/accountInventory/getAccounts')
  },
}
</script>
<style lang="scss" scoped>
</style>
